/**
 * Live dictation's words: what is settled, and the tail still being heard.
 *
 * The socket sends each phrase over and over as it firms up (`final: false`),
 * then once for good (`final: true`). A final is kept; the rest only ever
 * replaces the tail.
 */

export interface Dictation {
  finals: string;
  interim: string;
}

export const NO_DICTATION: Dictation = { finals: '', interim: '' };

/** Two pieces of text with one space between them, where they need it. */
export function joinText(a: string, b: string): string {
  if (!a) return b;
  if (!b) return a;
  return /\s$/.test(a) || /^\s/.test(b) ? a + b : `${a} ${b}`;
}

export function hear(d: Dictation, e: { text: string; final: boolean }): Dictation {
  const text = e.text.trim();
  if (!e.final) return { ...d, interim: text };
  return { finals: joinText(d.finals, text), interim: '' };
}

/** Everything heard so far. */
export const heard = (d: Dictation): string => joinText(d.finals, d.interim);
